import { jsx as s, jsxs as g, Fragment as S } from "react/jsx-runtime";
import I, { useContext as f, createContext as L } from "react";
import B from "clsx";
import { ClientOnly as j } from "@made-people/ui-components-client-only";
import { bannerStyling as u } from "./index-blueprint.es.js";
import { responsiveVideoSchema as x, ResponsiveVideo as A } from "@made-people/blueprint-responsive-video";
import { ResponsiveImage as y, responsiveImageSchema as C } from "@made-people/blueprint-responsive-image";
import { useInGrid as G } from "@made-people/blueprint-grid";
import { z as m } from "zod";
import { withZod as N } from "@made-people/react-prop-guard";
import { buttonAsButtonSchema as W, ButtonAsLink as R } from "@made-people/blueprint-button";
import { linkAsLinkSchema as D, LinkAsLink as M } from "@made-people/blueprint-link";
import { headingSchema as P, Heading as T } from "@made-people/blueprint-heading";
import { useLink as $ } from "@made-people/grease-link";
import { withManagedProps as E } from "@made-people/managed-props";
import { componentWrapperSchema as F, ComponentWrapper as H } from "@made-people/blueprint-component-wrapper";
import { breakpointVisibilitySchema as O, useBreakpoint as Z } from "@made-people/blueprint-ui-hooks";
import "@made-people/blueprint";
const q = x, w = I.forwardRef(({ className: n, ...t }, a) => {
  var p, c, l;
  const e = f(h);
  if (!e)
    return null;
  const { variants: i, settings: o } = e;
  if (!(o != null && o.video) || !((p = o == null ? void 0 : o.video) != null && p.src) || typeof o.video.src == "object" && !((c = o.video.src) != null && c.mobile) && !((l = o.video.src) != null && l.desktop))
    return null;
  const r = u.styles(i);
  return /* @__PURE__ */ s(j, { children: /* @__PURE__ */ s(
    A,
    {
      ref: a,
      className: B(r.background, n),
      ...o == null ? void 0 : o.video
    }
  ) });
});
w.displayName = "BackgroundVideo";
const J = () => {
  var b;
  const n = G(), t = f(h), a = ((b = t == null ? void 0 : t.variants) == null ? void 0 : b.splitImage) === "true";
  if (!t)
    return null;
  const { variants: e, settings: i } = t, o = u.styles(e);
  if (!(i != null && i.image))
    return null;
  const r = t.isMainContent ?? !0, p = r ? "eager" : "lazy", c = r ? "high" : "auto", l = i.splitImage && (() => {
    var z;
    const d = i.splitImage, v = (z = d.initial ?? d.image) == null ? void 0 : z.src, k = d.lg ?? d.desktopImage;
    return v ? d : k != null && k.src ? { ...d, initial: k } : d;
  })();
  return /* @__PURE__ */ g(S, { children: [
    !a && /* @__PURE__ */ s(
      y,
      {
        loading: p,
        fetchpriority: c,
        ...i.image,
        displaySize: n ? t.inGridDisplaySize : i.image.displaySize,
        className: o.background
      }
    ),
    a && l && /* @__PURE__ */ g(S, { children: [
      /* @__PURE__ */ s(
        y,
        {
          loading: p,
          fetchpriority: c,
          ...i.image,
          displaySize: i.image.displaySize,
          className: o.backgroundSplitLeft
        }
      ),
      /* @__PURE__ */ s(
        y,
        {
          loading: p,
          fetchpriority: c,
          ...l,
          displaySize: l.displaySize ?? i.image.displaySize,
          className: o.backgroundSplitRight
        }
      )
    ] })
  ] });
}, V = m.object({
  children: m.custom().array().optional(),
  linkVariants: D.shape.variants.optional(),
  buttonVariants: W.shape.variants.optional()
}), K = N(V, () => {
  var o, r, p, c;
  const n = f(h);
  if (!n)
    return null;
  const { variants: t, settings: a } = n, { ctasWrapper: e } = u.styles(t);
  if (!((r = (o = a == null ? void 0 : a.ctas) == null ? void 0 : o.children) != null && r.length))
    return null;
  const i = (t == null ? void 0 : t.splitImage) === "true";
  return /* @__PURE__ */ s(
    "div",
    {
      className: e,
      "data-split-image": i ? "true" : "false",
      children: (c = (p = a == null ? void 0 : a.ctas) == null ? void 0 : p.children) == null ? void 0 : c.map((l, b) => {
        var d, v;
        if (I.isValidElement(l))
          return l;
        if (l && typeof l == "object" && "component" in l)
          switch (l.component) {
            case "ButtonAsLink":
              return /* @__PURE__ */ s(
                R,
                {
                  variants: (d = a == null ? void 0 : a.ctas) == null ? void 0 : d.buttonVariants,
                  ...l
                },
                `button-${b}`
              );
            case "LinkAsLink":
              return /* @__PURE__ */ s(
                M,
                {
                  variants: (v = a == null ? void 0 : a.ctas) == null ? void 0 : v.linkVariants,
                  ...l
                },
                `link-${b}`
              );
          }
        return null;
      })
    }
  );
}), Q = m.object({ label: m.string() }).array(), U = () => {
  const n = f(h);
  if (!n)
    return null;
  const { variants: t, settings: a } = n, e = a == null ? void 0 : a.tags, i = u.styles(t);
  return e ? /* @__PURE__ */ s("div", { className: i.tagsWrapper, children: e == null ? void 0 : e.map((o, r) => /* @__PURE__ */ s("span", { className: i.tag, children: o.label }, r)) }) : null;
}, X = m.object({
  heading: P.optional()
}), Y = () => {
  var o, r, p, c, l;
  const n = f(h);
  if (!n)
    return null;
  const { variants: t, settings: a } = n, e = u.styles(t);
  return ((o = a == null ? void 0 : a.heading) == null ? void 0 : o.heading) || ((p = (r = a == null ? void 0 : a.heading) == null ? void 0 : r.badge) == null ? void 0 : p.label) || ((c = a == null ? void 0 : a.heading) == null ? void 0 : c.eyebrow) || ((l = a == null ? void 0 : a.heading) == null ? void 0 : l.lead) || (a == null ? void 0 : a.ctas) || (a == null ? void 0 : a.tags) ? /* @__PURE__ */ g(S, { children: [
    /* @__PURE__ */ g("div", { className: e.contentWrapper, children: [
      /* @__PURE__ */ s(U, {}),
      /* @__PURE__ */ s(T, { ...a == null ? void 0 : a.heading, className: e.headingWrapper }),
      /* @__PURE__ */ s(K, {})
    ] }),
    /* @__PURE__ */ s(
      "div",
      {
        className: B(
          "absolute h-full w-full right-0 top-0",
          e.contentShadow
        )
      }
    )
  ] }) : null;
}, _ = () => {
  var o, r;
  const n = f(h), t = $();
  if (!n)
    return null;
  const { variants: a, settings: e } = n, i = u.styles(a);
  return (o = e == null ? void 0 : e.link) != null && o.href ? /* @__PURE__ */ s(
    t,
    {
      className: B("absolute w-full h-full left-0 top-0", i.link),
      href: e == null ? void 0 : e.link.href,
      "aria-label": `Go to ${((r = e.heading) == null ? void 0 : r.heading) ?? "page"}`
    }
  ) : null;
}, aa = (n) => {
  var i, o, r;
  if (!n)
    return { mobile: !1, tablet: !1, desktop: !1 };
  const t = !!((i = n.initial ?? n.image) != null && i.src), a = !!((o = n.md ?? n.tabletImage) != null && o.src), e = !!((r = n.lg ?? n.desktopImage) != null && r.src);
  return {
    mobile: t,
    tablet: t || a,
    desktop: t || a || e
  };
}, oa = m.object({
  variants: m.custom().optional(),
  layout: F.shape.layout.optional(),
  settings: m.object({
    tags: Q.optional(),
    heading: X.shape.heading.optional(),
    image: C.optional(),
    splitImage: C.optional(),
    video: q.optional(),
    link: m.object({
      href: m.string().optional()
    }).optional(),
    ctas: V.optional()
  }).optional(),
  visibility: O.optional(),
  // Toggles if we should use eager/high priority loading, defaults
  // to true.
  isMainContent: m.boolean().optional(),
  inGridDisplaySize: m.string().optional()
}), h = L(void 0), ya = E(
  "Banner",
  N(
    {
      schema: oa,
      defaultProps: {
        inGridDisplaySize: "25vw",
        settings: {
          image: {
            displaySize: "100vw"
          }
        }
      }
    },
    ({ layout: n, variants: t, ...a }) => {
      var c;
      const e = Z(), i = aa((c = a.settings) == null ? void 0 : c.splitImage), o = e.active && (i[e.active] ?? !1), r = {
        ...t,
        splitImage: o ? "true" : "false"
      }, p = u.styles(r);
      return /* @__PURE__ */ s(h.Provider, { value: { ...a, variants: r }, children: /* @__PURE__ */ g(
        H,
        {
          className: p.base,
          layout: { ...n },
          visibility: a.visibility,
          children: [
            /* @__PURE__ */ s(w, {}),
            /* @__PURE__ */ s(J, {}),
            /* @__PURE__ */ s(Y, {}),
            /* @__PURE__ */ s(_, {})
          ]
        }
      ) });
    }
  )
);
export {
  J as BackgroundImage,
  w as BackgroundVideo,
  ya as Banner,
  h as BannerContext,
  oa as BannerSchema,
  K as CTAs,
  Y as Content,
  _ as Link,
  U as Tags,
  q as backgroundVideoSchema,
  X as contentSchema,
  V as ctaSchema,
  aa as splitImageActiveAtBreakpoint,
  Q as tagsSchema
};
//# sourceMappingURL=index.es.js.map
